import { axios } from "utils";

import { ADMIN_DAIRY_URL as endpoint } from "consts";

import { DairyCowType, DairyFeedAdditive, DairyFeedType, DairyManureStorage } from "models";

export const getDairyCowTypesAdmin = async ({ enabled }: { enabled?: boolean } = {}): Promise<DairyCowType[]> =>
  axios.get(`${endpoint}/dairy-cow-types`, { params: { enabled } });

export const getDairyFeedAdditivesAdmin = async (): Promise<DairyFeedAdditive[]> => axios.get(`${endpoint}/dairy-feed-additives`);

export const getDairyFeedTypesAdmin = async ({ enabled }: { enabled?: boolean } = {}): Promise<DairyFeedType[]> =>
  axios.get(`${endpoint}/dairy-feed-types`, { params: { enabled } });

export const getDairyManureStorageAdmin = async (): Promise<DairyManureStorage[]> => axios.get(`${endpoint}/dairy-manure-storage-types`);
